/**
 * Simple Disclosure Component for Shopify Localization forms
 */
class Disclosure {
  constructor(container) {
    this.container = container;
    this.trigger = container.querySelector('[data-disclosure-trigger]');
    this.list = container.querySelector('[data-disclosure-list]');
    
    if (!this.trigger || !this.list) return;

    this.init();
  }

  init() {
    this.trigger.addEventListener('click', () => {
      const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
      this.trigger.setAttribute('aria-expanded', !isExpanded);
      this.list.toggleAttribute('hidden');
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.list.setAttribute('hidden', '');
      }
    });

    // Handle ESC key
    this.container.addEventListener('keyup', (e) => {
      if (e.code === 'Escape') {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.list.setAttribute('hidden', '');
        this.trigger.focus();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const disclosureContainers = document.querySelectorAll('.localization-form__select');
  disclosureContainers.forEach(container => new Disclosure(container));
});
